import React from 'react'
import tw from 'tailwind-styled-components'

const TwTr = tw.tr<TrProps>`
  ${p => (p.$cursorPointer ? 'cursor-pointer' : '')}
  border-0
  hover:bg-chat-list-hover-old
  odd:bg-main-old
  even:bg-main-even-old
`

type TrProps = {
  $cursorPointer?: boolean
}

export interface Props {
  children?: React.ReactNode
  onClick?: () => void
  cursorPointer?: boolean
}

export const Row = (props: Props) => {
  const {children, onClick, cursorPointer = false} = props
  return (
    <TwTr onClick={onClick} $cursorPointer={cursorPointer}>
      {children}
    </TwTr>
  )
}
